import type { RetailEnvironmentConfig } from '@retail/core-config';
import { getEnv } from '@luna/env';
import { getCurrentLanguage } from '@luna/i18n';
import { getAuthData, logoutOidcProvider } from '@luna/oidc';
import { logger } from '@luna/logger';
import { clearRetailTokenFromPersistentStorage } from '@retail/core';

import { getRpSdk } from './rpSdk';

function logoutWithRpSdk(): Promise<void> {
    const rpSdk = getRpSdk();
    const { rpLogoutUri } = getEnv<RetailEnvironmentConfig>();
    const logoutUrl = rpLogoutUri.replace('[[CURRENT_GEORGE_LANGUAGE]]', getCurrentLanguage());
    return rpSdk.logout({
        postLogoutRedirectUri: logoutUrl,
    });
}

export const logoutWithOIDC = (): Promise<void> => {
    clearRetailTokenFromPersistentStorage();
    if (getEnv().country === 'CZ') {
        sessionStorage.clear();
        return logoutWithRpSdk();
    }

    const { idToken } = getAuthData();

    if (!idToken || !getEnv().auth?.endSessionUrl) {
        logger.error('Attempting logout with OIDC without idToken or proper env configuration');
        return Promise.resolve();
    }

    return Promise.resolve(logoutOidcProvider(getEnv().auth!.endSessionUrl, idToken));
};
